import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'ghost'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  children: ReactNode
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    'px-4 py-2 bg-swiss-black text-swiss-white text-[13px] font-medium transition-colors duration-150 hover:bg-swiss-gray-700 disabled:opacity-50 disabled:cursor-not-allowed',
  secondary:
    'px-4 py-2 bg-swiss-white text-swiss-black text-[13px] font-medium border border-swiss-gray-200 transition-colors duration-150 hover:bg-swiss-off-white disabled:opacity-50 disabled:cursor-not-allowed',
  ghost:
    'text-[13px] text-swiss-gray-500 transition-colors duration-150 hover:text-swiss-black disabled:opacity-50 disabled:cursor-not-allowed',
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', children, className = '', ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`${variantClasses[variant]} ${className}`}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
